module.exports = __webpack_public_path__ + "static/img/img-logo.44f9f62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/img-logo.png
// module id = 2ivg
// module chunks = 0